var _path, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgNext(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "icon/navigation/expand_more_24px copy 5"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_408_5643",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 7,
    y: 5,
    width: 6,
    height: 10
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "icon/navigation/expand_more_24px",
    d: "M7.4996 6.77083L10.7329 10.0042L7.4996 13.2375C7.34355 13.3932 7.25586 13.6046 7.25586 13.825C7.25586 14.0454 7.34355 14.2568 7.4996 14.4125C7.8246 14.7375 8.3496 14.7375 8.6746 14.4125L12.4996 10.5875C12.8246 10.2625 12.8246 9.7375 12.4996 9.4125L8.6746 5.5875C8.3496 5.2625 7.8246 5.2625 7.4996 5.5875C7.18293 5.9125 7.1746 6.44583 7.4996 6.77083Z"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_408_5643)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "\xE2\x86\xB3 Color"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    y: 20,
    width: 20,
    height: 20,
    transform: "rotate(-90 0 20)"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNext);
export default __webpack_public_path__ + "static/media/next.2d21185394f7ed683e6ac8152b927136.svg";
export { ForwardRef as ReactComponent };